<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4">
                <span class="fs-14 pd-r-10">特属专家姓名：</span>
                <el-input v-model="user_name" placeholder="特属专家姓名模糊搜索"/>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'doctorDownload'" @click="exportExcel">导出数据</el-button>
        </div>


        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
            <el-table-column prop="user_name" label="特属专家姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="reservation_count" label="预约数" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="reservation_date" label="最近预约时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="reservation_client_name" label="最近预约特属服务对象" align="center" label-class-name="label"></el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                user_name:'',
            };
        },
        created() {

        },
        mounted() {
            // 获取列表
            this.getList();
            localStorage.setItem('prev_page', 'usercontract_list')
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'doctorReservation',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_name: this.user_name,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                this.user_name = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                this.page = 1;
                this.getList();
            },

            // 导出数据
            exportExcel() {
                let params = {
                    servername: 'Ruyi_StatementsServices',
                    method: 'doctorReservation',
                    pageinfo: {
                        page: this.page,
                        perpage: 0,
                    },
                    params: {
                        user_name: this.user_name,
                    }
                };
                let colums_list = [
                    {title: "特属专家姓名", key: "user_name"},
                    {title: "预约数", key: "reservation_count"},
                    {title: "最近预约时间", key: "reservation_date"},
                    {title: "最近预约特属服务对象", key: "reservation_client_name"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        return false;
                    }

                    for (let i = 0; i < res_data.data.list.length; i++) {
                        let item = {
                            user_name: res_data.data.list[i].user_name,
                            reservation_count: res_data.data.list[i].reservation_count,
                            reservation_date: res_data.data.list[i].reservation_date,
                            reservation_client_name: res_data.data.list[i].reservation_client_name,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出特属专家会面报表");
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
</style>
